<template>
  <div class="maincen">
    <div class="title-bg">
      <div class="main bg">
        <div class="title-bar"></div>
        <div class="title-text">教材详情</div>
        <div class="back" @click="goback">返回 >></div>
      </div>
      <div class="line"></div>
      <div class="tebleitem">
        <div class="itemmt">
          <span class="labekkey commontext">教师姓名:</span>
          <span class="labelvalue commontext">{{resnickname}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">手机号:</span>
          <span class="labelvalue commontext">{{resPhone}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">工作单位:</span>
          <span class="labelvalue commontext">{{resSchName}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">职位:</span>
          <span class="labelvalue commontext">{{professional}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">出版类型:</span>
          <span class="labelvalue commontext">{{bookType[data.textbookType]}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">计划书名:</span>
          <span class="labelvalue commontext">{{data.projectTitle}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">选题名称:</span>
          <span class="labelvalue commontext">{{data.topicName}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">内容摘要:</span>
          <span class="labelvalue commontext">{{data.synopsis}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">申请说明:</span>
          <span class="labelvalue commontext">{{data.auditExplain}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">出版内容及特色价值:</span>
          <span class="labelvalue commontext">{{data.publishContent}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">上传稿件:</span>
          <span class="labelvalue commontext">{{data.manuscriptFileName}}</span>
        </div>
        <div class="itemmt">
          <span class="labekkey commontext">上传配套资源:</span>
          <span class="labelvalue commontext">{{data.resourceFileName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Loading } from 'element-ui'
import { getzhichengStr,  } from '../../assets/tool'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { fetchPunblishDetail } from '../../api/wapi';
import BookTable from '../chooseBooks/common/book-table'
Vue.component('book-table', BookTable)
export default {
  computed: {
        ...mapGetters(['resPhone','resSchName','resnickname','resProfessional','']),
  },
  data() {
    return {
      tabelLoading: false,
      isShowView: false,
      sheetId: '',
      data:{},
      professional:'',
      isUpdate: true,
      bookType:{
        8:'一般教材',
        5:'省规划教材'
      },
      bookList: [],
    }
  },
  created() {
    console.log('拿到的数据====', this.$route.query)
    this.sheetId = this.$route.query.fid
    this.professional = getzhichengStr(this.resProfessional);
    this.loadData()
  },
  methods: {
    checkAdult(item) {
      return item.status < 2
    },
    loadData(){
      console.log("");
      fetchPunblishDetail(this.sheetId).then((result) => {
        console.log("result======>",result);
        this.data = result&&result.data;
      }).catch((err) => {
        
      });
    },
    goback() {
      this.$router.go(-1)
    },
    goBackHome() {
      this.$router.push('/')
    },
    deleteDone(dataList) {
      this.bookList = dataList
    },
    hideModal() {
      this.isShowView = false
    },
    // 提交成功
    updateAction() {
      let loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(0,0,0,0.5)',
      })
      updateBookList(this.bookList)
        .then((result) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
          this.isShowView = true
          this.loadList()
        })
        .catch((err) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        })
    },
  },
}
</script>

<style  scoped>
.tebleitem {
  padding:0px 20px;
  padding-top: 20px;
}
.commontext {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.labelvalue{
  line-height: 20px;
  padding: 10px;
}
.border{
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}
.itemmt {
  /* margin: 15px 0; */
  display: flex;
}
.labekkey {
  display: inline-block;
  width: 160px;
  padding: 10px;
  min-width: 160px;
  /* height: 30px;
  line-height: 30px; */
}
.maincen {
  margin: 0px 40px;
  height: 740px;
  background-color: white;
}
.title-bg {
  height: 78px;
}
.bg {
  padding-top: 20px;
  padding-left: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  position: relative;
}
.back {
  position: absolute;
  right: 40px;
  font-size: 12px;
  color: #666666;
  cursor: pointer;
}
.title-bar {
  width: 8px;
  height: 18px;
  background: #274C9F;
}
.title-text {
  margin-left: 8px;
  color: #333333;
  font-size: 18px;
}
.line {
  margin-top: 10px;
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
}
/* 提交成功弹框 */
.mask-bg {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 100;
}
.submit-modal {
  margin-top: 200px;
  background-color: white;
  width: 380px;
  height: 300px;
}
.submit-head {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.close-btn {
  width: 44px;
  height: 44px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0082F0;
}
.close-image {
  width: 20px;
  height: 20px;
}
.content {
  margin: 0px;
  width: 100%;
  height: 100%;
  text-align: center;
}
.success-image {
  margin-top: 19px;
  width: 48px;
  height: 48px;
}
.success-text {
  font-size: 14px;
  color: #333333;
  text-align: center;
  margin-top: 19px;
}
.success-btn {
  color: white;
  background-color: #0082F0;
  width: 96px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  margin: auto;
  margin-top: 50px;
}
.submit-bg {
  width: 100%;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.submit-mask {
  position: absolute;
  display: flex;
  bottom: 0px;
  right: 0px;
  left: 240px;
  height: 56px;
  z-index: 0;
  background-color: white;
  -moz-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.15);
}
.submit-btn {
  background-color: #0082F0;
  color: white;
  height: 56px;
  text-align: center;
  line-height: 56px;
  width: 100px;
}
.msg {
  font-size: 13px;
  color: #333333;
  margin-right: 10px;
}
</style>